import { Card, CardContent } from '@/components/ui/Card.jsx';
import { cn } from '@/lib/cn.js';

export function StatCard({ label, value, hint, icon: Icon, accent = 'brand', className }) {
  const accents = {
    brand: 'bg-brand-100 text-brand-700 dark:bg-brand-900/40 dark:text-brand-300',
    success: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
    warning: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
    danger: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
    info: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
  };
  return (
    <Card className={className}>
      <CardContent className="flex items-center gap-4">
        {Icon && (
          <div className={cn('flex h-11 w-11 items-center justify-center rounded-lg', accents[accent])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
        <div>
          <p className="text-sm text-slate-500 dark:text-slate-400">{label}</p>
          <p className="mt-0.5 text-xl font-semibold text-slate-900 dark:text-slate-100">{value}</p>
          {hint && <p className="mt-0.5 text-xs text-slate-400">{hint}</p>}
        </div>
      </CardContent>
    </Card>
  );
}
